var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstackIconOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.539 8.242H1.45996V5.406H22.54V8.242H22.539ZM1.45996 10.812V24L12 18.11L22.54 24V10.812H1.45996ZM22.54 0H1.45996V2.836H22.54V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstackIconOriginal);
export default __webpack_public_path__ + "static/media/substack-icon-original.991262bf6d0b2d696bd61d7281d1d87d.svg";
export { ForwardRef as ReactComponent };